export default {
  originCity: 'Välj stad för avresa',
  destinationCity: 'Välj ankomststad',
  direct: 'Direkt',
  indirect: '1+ stopp',
  getPrices: 'Hitta erbjudanden',
  directAvailable: 'Direkt tillgänglig från',
}
